import Marquee from "./marquee";

function install(Vue) {
  Vue.directive("Marquee", Marquee);
}
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}
Marquee.install = install;
export default Marquee;
